import * as yup from "yup";

const validMessage = `Please use correct email format!`;

export const inspectorSchema = yup.object().shape({
  full_name: yup
    .string()
    .min(3, "Name too short")
    .max(255, "Name too long")
    .required("Name is required."),
  email: yup
    .string()
    .min(3, "Email too short!")
    .max(255, "Email too long!")
    .email(validMessage)
    .required("Email is required."),
  phone: yup
    .string()
    .min(3)
    .max(255, validMessage)
    .required("Phone is required."),
  cnic: yup.string().min(3).max(255).required("CNIC is required."),
});
